import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
// eslint-disable-next-line no-restricted-imports
import Vuex from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vuex.js?vue3';
import * as actions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/super_sidebar/components/global_search/store/actions.js?vue3';
import * as getters from './getters';
import mutations from './mutations';
import createState from './state';

Vue.use(Vuex);

export const getStoreConfig = ({ searchContext, search }) => ({
  actions,
  getters,
  mutations,
  state: createState({ searchContext, search }),
});

const createStore = (config) => new Vuex.Store(getStoreConfig(config));
export default createStore;
